'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Components


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DragHandle = require('./DragHandle');

var _DragHandle2 = _interopRequireDefault(_DragHandle);

require('./EdgeDragHandle.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EdgeDragHandle = function EdgeDragHandle(props) {
    return _react2.default.createElement(_DragHandle2.default, _extends({ className: 'EdgeDragHandle' }, props));
};

EdgeDragHandle.propTypes = {
    show: _propTypes2.default.bool,
    pos: _propTypes2.default.object
};

exports.default = EdgeDragHandle;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/line/EdgeDragHandle.js
// module id = 735
// module chunks = 0